export default __webpack_public_path__ + "static/media/demoIcon.daa81899.png";